<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.annualSales.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.annualSales.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.annualSales.export')}}</el-button>
                <span class="toptotalWeight">
                    {{$t('pages.annualSales.total')}}
                    <el-input v-model="totalWeight" class="handle-select" disabled></el-input>
                </span>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.StatrtYear" type="year" :placeholder="$t('pages.annualSales.startYear')" class="handle-select mr10" :picker-options="pickerOptions0" style="width:20%;"></el-date-picker>
                <el-date-picker v-model="query.EndYear" type="year" :placeholder="$t('pages.annualSales.endYear')" class="handle-select mr10" :picker-options="pickerOptions0" style="width:20%;"></el-date-picker>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.annualSales.search')}}</el-button>
            </div>
        </div>

            <el-table :data="logRecords" border class="table" header-cell-class-name="table-header" id="mytable" ref="mytable" :height="tableHeight">
            <el-table-column type="index" width="80" :label="$t('pages.annualSales.index')"></el-table-column>
            <el-table-column sortable prop="date" :label="$t('pages.annualSales.year')">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    {{ scope.row.date | formateData }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('pages.annualSales.yearSales')">
                <template slot-scope="scope">
                    <el-button type="text" style="color:#606266;font-size: 15px;padding-top: 0px;padding-bottom: 8px;">{{scope.row.annualSales}}</el-button>
                </template>
            </el-table-column>
            <el-table-column :label="$t('pages.annualSales.yearCarCount')">
                <template slot-scope="scope">
                    <el-button type="text" style="color:#606266;font-size: 15px;padding-top: 0px;padding-bottom: 8px;">{{scope.row.carCount}}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField,
    dateAdd
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            tableHeight: window.innerHeight * 0.75,
            totalWeight: '',
            frequencyArr: [],
            balanceArr: [],
            logRecords: [],
            multipleSelection: [],
            query: {
                StatrtYear: '',
                EndYear: '',
                balanceId: 0
            }
        };
    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy年');
        }
    },
    created() {
        this.query.StatrtYear = new Date();
        this.query.EndYear = new Date();
        this.getBalance();
        this.getData();
    },
    methods: {
        getData() {
            var syear = new Date(this.query.StatrtYear).getFullYear();
            var eyear = new Date(this.query.EndYear).getFullYear();
            this.$zybhttp
                .get('ProdInquiry/AnnualSalesData', {
                    params: {
                        StatrtYear: syear,
                        EndYear: eyear,
                        balanceId: this.query.balanceId
                    }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.logRecords = d;
                        this.totalWeight = res.data.msg;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.annualSales.fetchError')));
        },
        getBalance() {
            this.$zybhttp
                .post('Balance/GetList', {
                    Field3: '1',
                    Field4: '3'
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = [{
                            id: 0,
                            name: this.$t('pages.salesDetails.all')
                        }].concat(d).sort(SortField('id', 'asc'));
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.annualSales.fetchError')));
        },
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy年');
        },
        printlist() {
            var newdata = JSON.parse(JSON.stringify(this.logRecords));
            // 进行格式处理的数据
            newdata.forEach((item, index, arr) => {
                item.index = index + 1;
                item.date = this.formateData(item.date); // 日期格式处理
            });
            // 打印方法
            print({
                printable: newdata,
                header: `<div style="display: flex;flex-direction: column;text-align: center">
                        <h3>${this.$t('pages.annualSales.printTitle')}</h3>
                    </div>`,
                properties: [{
                        field: 'index',
                        displayName: this.$t('pages.annualSales.index'),
                        columnSize: `5%`
                    },
                    {
                        field: 'date',
                        displayName: this.$t('pages.annualSales.year'),
                        columnSize: `20%`
                    },
                    {
                        field: 'annualSales',
                        displayName: this.$t('pages.annualSales.yearSales'),
                        columnSize: `10%`
                    },
                    {
                        field: 'carCount',
                        displayName: this.$t('pages.annualSales.yearCarCount'),
                        columnSize: `10%`
                    },
                ],
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:center;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.annualSales.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
    margin-right: -195px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.toptotalWeight {
    float: right;
    margin-left: 30px;
}
</style>
